<div class="page">
    <!-- <lib-ph-bhp-header></lib-ph-bhp-header> -->
    <div class="page-content d-flex align-items-stretch">
      <nav class="side-navbar">
       </nav>
        <lib-ph-bhp-user-registration (childData)="onSaveUser($event)"></lib-ph-bhp-user-registration>
    </div>
</div>
